import { render, staticRenderFns } from "./pwdsetting.vue?vue&type=template&id=59b0484d"
import script from "./pwdsetting.vue?vue&type=script&lang=js"
export * from "./pwdsetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports